import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmploymentOverviewComponent } from './employment-overview.component';
import { VerificationStatusModule } from "../../components/verification-status/verification-status.module";
import { TooltipModule } from 'ngx-bootstrap/tooltip';


@NgModule({
  declarations: [EmploymentOverviewComponent],
  imports: [
    CommonModule,
    VerificationStatusModule,
    TooltipModule.forRoot(),
  ],
  exports: [
    EmploymentOverviewComponent,
  ]
})
export class EmploymentOverviewModule { }
